<template>
  <ul class="md-list" :class="[themeClass]">
    <slot></slot>
  </ul>
</template>

<style lang="scss" src="./mdList.theme.scss"></style>
<style lang="scss" src="./mdList.scss"></style>

<script lang="ts" setup>
import {  provide, inject, toRef } from 'vue'
import { useTheme } from '../../core/theme/components';

const props = defineProps<{
  mdTheme?: string,
}>();

const { themeClass } = useTheme(toRef(props, 'mdTheme'));

var expandedList = [];

provide('mdList', {
  getExpandedList() { return expandedList; },
  registerExpanded(item) { expandedList.push(item); },
  removeExpanded(item) { expandedList = expandedList.filter(i => i != item); }
})


</script>
